import {
  ALL_LAYOUT_RESIZE_HANDLES,
  type LayoutResizeHandle,
} from "~/v3-poc/features/workspace/shared/layoutSettings/layoutSettings.types";

export type RglCompactorMode =
  | "vertical"
  | "horizontal"
  | "none"
  | "vertical-overlap"
  | "horizontal-overlap"
  | "none-overlap";

export type ReactGridLayoutSettings = {
  cols: number;
  rowHeight: number;
  marginX: number;
  marginY: number;
  containerPaddingMode: "margin" | "custom";
  containerPaddingX: number;
  containerPaddingY: number;
  maxRows: { limited: boolean; value: number };
  autoSize: boolean;
  compactor: RglCompactorMode;
  bounded: boolean;
  dragThreshold: number;
  resizeHandles: ReadonlyArray<LayoutResizeHandle>;
  positionStrategy: "transform" | "absolute" | "scaled";
  positionScale: number;
  gridBounds: boolean;
  containerBounds: boolean;
  boundedX: boolean;
  boundedY: boolean;
  minMaxSize: boolean;
  globalMin: { enabled: boolean; w: number; h: number };
  globalMax: { enabled: boolean; w: number; h: number };
  snap: { enabled: boolean; x: number; y: number };
  aspect: { enabled: boolean; ratio: number };
  externalDrop: { enabled: false; w: number; h: number };
};

export const DEFAULT_REACT_GRID_LAYOUT_SETTINGS: ReactGridLayoutSettings = {
  cols: 24,
  rowHeight: 30,
  marginX: 8,
  marginY: 8,
  containerPaddingMode: "margin",
  containerPaddingX: 8,
  containerPaddingY: 8,
  maxRows: { limited: false, value: 100 },
  autoSize: true,
  compactor: "vertical",
  bounded: false,
  dragThreshold: 3,
  resizeHandles: [...ALL_LAYOUT_RESIZE_HANDLES],
  positionStrategy: "transform",
  positionScale: 1,
  gridBounds: true,
  containerBounds: false,
  boundedX: false,
  boundedY: false,
  minMaxSize: true,
  globalMin: { enabled: false, w: 1, h: 1 },
  globalMax: { enabled: false, w: 24, h: 40 },
  snap: { enabled: false, x: 1, y: 1 },
  aspect: { enabled: false, ratio: 16 / 9 },
  externalDrop: { enabled: false, w: 1, h: 1 },
};
